module.exports = "/static/js/08f11029984a1d8a39608156634f2aa0.png";